import React, { useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import {
  deactivateClientUserAuthAccountSlice,
  patchDeactivateClientUserAsyncAction,
} from 'store/order/clientLenderContacts/clientUserAuthAccountSlice';
import { useAppDispatch } from 'store/store';
import { RootStore } from 'store/types';
import { IPresentationClientUserData } from 'types/clients/IClientUser';
import { ContactActionDialog } from 'components/lenders/ContactActionDialog';
import { eClientContactActionType } from 'types/contacts/eClientContactActionType';
import { ClientUsersAPI } from 'API/clients/ClientUsersApi';
import { eAPITags } from '../../API/eAPITags';

export interface IDeactivateClientUserProps {
  done: () => void;
  user: IPresentationClientUserData;
  clientCompanyId: string;
}

export const DeactivateClientUser: React.FC<IDeactivateClientUserProps> = ({ done, user, clientCompanyId }) => {
  const dispatch = useAppDispatch();
  const onReset = useCallback(() => dispatch(deactivateClientUserAuthAccountSlice.actions.reset({})), [dispatch]);
  useEffect(() => {
    onReset();
  }, [onReset]);
  const deactivate = async () => {
    await dispatch(patchDeactivateClientUserAsyncAction({ clientCompanyId, clientUserId: user.id }));
    dispatch(ClientUsersAPI.util.invalidateTags([{ type: eAPITags.ClientUsers, id: clientCompanyId }]));
  };
  const { fetchStatus, fetchError } = useSelector(
    (store: RootStore) => store.clientLenderContacts.deactivateClientUserAuthAccountSlice
  );
  return (
    <ContactActionDialog
      onDone={done}
      onReset={onReset}
      onAction={deactivate}
      fetchStatus={fetchStatus}
      fetchError={fetchError}
      email={user.email}
      name={`${user.firstName} ${user.lastName}`}
      actionType={eClientContactActionType.Deactivate}
    />
  );
};
